import type { PropsWithChildren } from "react";

import TelemetryButton, { type ITelemetryButtonProps } from "@/design-system/telemetry-button";
import * as stylex from "@stylexjs/stylex";

import { type QueryXsMax, colors } from "./../../styles/tokens.stylex";

export interface SearchGroupProps extends PropsWithChildren {
    count: number;
    currentCount: number;
    title: string;
    button?: ITelemetryButtonProps;
    text: string;
}

export default function SearchGroup({
    count,
    currentCount,
    title,
    children,
    button,
    text,
}: SearchGroupProps) {
    if (count === 0) return null;

    return (
        <section {...stylex.props(styles.searchGroup)}>
            <h1 {...stylex.props(styles.title)}>
                {title} <span {...stylex.props(styles.span)}>({count})</span>
            </h1>
            {children}
            {count > currentCount &&
                (button ? (
                    <TelemetryButton
                        {...button}
                        styleX={[styles.button, button?.styleX]}
                        variant="transparent"
                    >
                        {`${text} (${count})`}
                    </TelemetryButton>
                ) : null)}
        </section>
    );
}

const xsMax: QueryXsMax = "@media (max-width: 759px)";

const styles = stylex.create({
    searchGroup: {
        marginBlock: "24px",
        marginInline: "0",
    },
    title: {
        margin: {
            default: "24px 0",
            [xsMax]: "1rem 0",
        },
        color: colors.fg_BrandBlue,
        fontSize: {
            default: "1.5rem",
            [xsMax]: "1.25rem",
        },
        fontWeight: 700,
        lineHeight: {
            default: 1.4,
            [xsMax]: 1.2,
        },
    },
    span: {
        color: colors.fg_Secondary,
    },
    button: {
        padding: 0,
        display: "block",
        fontWeight: "bold",
        marginBottom: "0.5rem",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "1.75rem",
        width: "max-content",
    },
});
